import PropTypes from 'prop-types';
import React from 'react';

function FloatingContent(props) {

    let alignClass = ""

    switch (props.align) {
        case "left":
            alignClass = "floating-content--left "
            break
        case "right":
            alignClass = "floating-content--right "
            break
        default:
            alignClass = ""
            break
    }

    return (
        <div className={props.className + " " + alignClass + "floating-content"}>
            {props.children}
        </div>
    );

}

FloatingContent.propTypes = {
    align: PropTypes.string,
    width: PropTypes.number,
    className: PropTypes.string
};

export default FloatingContent


/** WEBPACK FOOTER **
 ** ./src/components/FloatingContent.js
 **/